import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';
import customFetchBase from '../expiredToken/expiredToken';
import {
  ICommandBrightness,
  ICommandOnOff,
  ICommandPattern,
  ICommandSetColor,
  ICommandTurnOff
} from '../../types/commandsInterface';

const customFetch = customFetchBase(config.baseUrlDealers);

export const apiCommands = createApi({
  baseQuery: customFetch,
  endpoints: (builder) => ({
    sendOnOffCommand: builder.mutation<'', ICommandOnOff>({
      query: (payload) => ({
        url: `api/Commands/${payload.method}`,
        method: 'POST',
        body: {
          id: payload.id,
          type: payload.type
        }
      })
    }),
    sendBrightnessCommand: builder.mutation<'', ICommandBrightness>({
      query: (payload) => ({
        url: `api/Commands/Brightness`,
        method: 'POST',
        body: payload
      })
    }),
    sendColorCommand: builder.mutation<'', ICommandSetColor>({
      query: (payload) => ({
        url: `api/Commands/SetColor`,
        method: 'POST',
        body: payload
      })
    }),
    sendTurnOnPatternCommand: builder.mutation<'', ICommandPattern>({
      query: (payload) => ({
        url: `api/Commands/On/Pattern`,
        method: 'POST',
        body: payload
      })
    }),
    sendTurnOffDevicesCommand: builder.mutation<'', ICommandTurnOff>({
      query: (payload) => ({
        url: `api/Commands/Off`,
        method: 'POST',
        body: payload
      })
    }),
    setEnableOrDisable: builder.mutation<
      '',
      { configurationId: number; enabled: boolean }
    >({
      query: ({ configurationId, enabled }) => ({
        url: `api/ChannelConfiguration/Enabled/${configurationId}`,
        method: 'PUT',
        body: { enabled }
      })
    }),
    setProductType: builder.mutation<
      '',
      { configurationId: number; productType: number; deviceId: string }
    >({
      query: ({ configurationId, productType, deviceId }) => ({
        url: `api/Commands/ChannelLedSpacing`,
        method: 'POST',
        body: { productType, deviceId, lightId: configurationId }
      })
    }),
    setToogleDirection: builder.mutation<
      '',
      { lightId: number; isReverse: boolean; deviceId: string }
    >({
      query: ({ lightId, isReverse, deviceId }) => ({
        url: `api/Commands/ChannelDirection`,
        method: 'POST',
        body: { lightId, isReverse, deviceId }
      })
    }),
    setChannelOffset: builder.mutation<
      '',
      { lightId: number; offsetInches: number; deviceId: string }
    >({
      query: ({ lightId, offsetInches, deviceId }) => ({
        url: `api/Commands/ChannelOffset`,
        method: 'POST',
        body: { lightId, offsetInches, deviceId }
      })
    }),
    setProductLenght: builder.mutation<
      '',
      { id: number; productLength: number }
    >({
      query: ({ id, productLength }) => ({
        url: `api/ChannelConfiguration/ProductLength/${id}`,
        method: 'PUT',
        body: { productLength }
      })
    }),
    calculateLengthProduct: builder.mutation<
      '',
      {
        deviceId: string;
        lightId: number;
        startingOffset: number[];
        endingOffset: number[];
      }
    >({
      query: ({ deviceId, lightId, startingOffset, endingOffset }) => ({
        url: `api/Device/CalculateProductLength`,
        method: 'POST',
        body: { deviceId, lightId, startingOffset, endingOffset }
      })
    })
  })
});

export const {
  useSendOnOffCommandMutation,
  useSendColorCommandMutation,
  useSendBrightnessCommandMutation,
  useSendTurnOnPatternCommandMutation,
  useSendTurnOffDevicesCommandMutation,
  useSetEnableOrDisableMutation,
  useSetProductTypeMutation,
  useSetToogleDirectionMutation,
  useSetChannelOffsetMutation,
  useSetProductLenghtMutation,
  useCalculateLengthProductMutation
} = apiCommands;
